/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const bicycle = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M14.236 3.812h-3.223c-.322.001-.549.344-.436.644l.654 1.724M7.067 3.812l-1.87-.474M3.863 3l1.334.338m1.895 4.826L5.197 3.338m1.895 4.826 4.14-1.984m-4.14 1.984-1.649.79m5.788-2.774.598 1.577M5.443 8.955a2.332 2.332 0 0 0-2.11-1.356C2.045 7.6 1 8.66 1 9.966c0 1.308 1.045 2.367 2.333 2.367 1.289 0 2.334-1.06 2.334-2.367 0-.362-.08-.705-.224-1.011Zm6.386-1.198a2.367 2.367 0 0 0-1.496 2.21c0 1.307 1.045 2.366 2.334 2.366 1.288 0 2.333-1.06 2.333-2.367S13.955 7.6 12.667 7.6a2.3 2.3 0 0 0-.838.158Z"
    />
  </svg>
)
export default bicycle
